var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate90({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 504",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate90",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.333,224.333 L12,224.333 C5.373,224.333 0,218.96 0,212.333 L0,12 C0,5.373 5.373,0 12,0 L60,0 C66.627,0 72,5.373 72,12 L72,90.112 C117.773,39.279 184.26,7.47 258.175,8.007 C395.081,9.001 504.623,119.63 504.332,256.539 C504.041,393.258 393.12,504 256.333,504 C192.244,504 133.837,479.687 89.823,439.785 C84.724,435.163 84.489,427.231 89.356,422.365 L123.323,388.398 C127.797,383.924 134.985,383.681 139.724,387.873 C170.76,415.336 211.58,432 256.333,432 C353.601,432 432.333,353.284 432.333,256 C432.333,158.733 353.617,80 256.333,80 C197.837,80 146.053,108.476 114.059,152.333 L212.333,152.333 C218.96,152.333 224.333,157.706 224.333,164.333 L224.333,212.333 C224.333,218.96 218.96,224.333 212.333,224.333 Z",
    id: "Shape",
    transform: "translate(252.166289, 252.000000) scale(-1, 1) translate(-252.166289, -252.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate90);
export default __webpack_public_path__ + "static/media/rotate90.8c1aa942e433ac72aa16115e141b388d.svg";
export { ForwardRef as ReactComponent };